import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import type { CurrencyDetectCollection } from './currency-detect.types';
import { transformCurrencyAjax } from '../currencies/currencies.transformers';

export function currencyDetectReducer(
  state: CollectionStateSlice<CurrencyDetectCollection> = {},
  action: CollectionActions<CurrencyDetectCollection>,
): CollectionStateSlice<CurrencyDetectCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'currencyDetect') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<CurrencyDetectCollection>(
          state,
          transformIntoDocuments([result], transformCurrencyAjax),
          order,
          ref,
        );
      }

      return state;
    }

    default:
      return state;
  }
}
